import React from "react";
import DatePicker from "react-datepicker";
import { ErrorMessage } from "formik";
import { Label } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import ReactInputMask from "react-input-mask";
const FormikDatePicker = ({

  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const { id, placeholder, label,onKeyDown, setcss } = props;
  let formatedDate = "";
  let classAdded = "form-control inner-shadow-field p-0";

  if (value) {
    formatedDate = new Date(value);
  }
  else if (props.value) {
    formatedDate = new Date(props.value);
  }
  const handleChange = (date) => {
    setFieldValue(name, date, true);
  };

  if (setcss) {
    classAdded = classAdded + " " + setcss;
  }



  return (
    <div className={classAdded}>
      {label && (
        <Label for={name} className="d-block">
          {label}
        </Label>
      )}
      <DatePicker
        id={id}
        invalid={Boolean(touched[name] && errors[name])}
        autoComplete="off"
        selected={formatedDate}
        onChange={handleChange}
        // customInput={<CustomInput inputRef={inputRef} />}
        name={name}
        dateFormat="MM/dd/yyyy"
        scrollableYearDropdown
            yearDropdownItemNumber={100}
           showMonthDropdown
            showYearDropdown
              onKeyDown={onKeyDown}
        placeholderText={placeholder}
            
        {...props}
        className="border-0 w-100 date-picker"
        customInput={
                                                    <ReactInputMask mask="99/99/9999"
                                                    value={new Date}
                                                    />
                                                }
        
      />

      <ErrorMessage
        name={name}
        render={(msg) => <div className="text-danger font-size-12">{msg}</div>}
      />
    </div>

  );
};
export default FormikDatePicker;
